<ng-template #loading>
   <lib-loading></lib-loading>
</ng-template>

<ng-template #invalid>
   <div class="common-pad1em common-tacenter">Unable to locate HAWB {{hawb}}</div>
</ng-template>

<ng-container *ngIf="hawb; else invalid">
   <ng-container *ngIf="mode === 'shipment'">
      <ng-container *ngIf="details.load( hawb ) | async as shipment; else loading">
         <ng-container *ngIf="shipment; else invalid">
            <div class="shipment-details">
               <h2 color="primary">Shipment Details</h2>
   
               <div class="service-label">HAWB #{{shipment.hawb}}</div>
   
               <div class="summary">
                  <div class="list summary-details">
                     <ng-container *ngIf="shipment.servicelevel">
                        <header color="primary">Service Level</header>
                        <span> {{shipment.servicelevel}}<br/></span>
                     </ng-container>
   
                     <ng-container *ngIf="allItems | async as items">
                        <header color="primary">Total Pieces</header>
                        <span> {{items | total : 'pieces' | number}}<br/></span>
   
                        <header color="primary">Total Weight</header>
                        <span> {{items | totaldualweight }}<br/></span>
   
                        <ng-container *ngIf="items | totalvolume">
                           <header color="primary">Volume</header>
                           <span> {{items | totaldualvolume }}<br/></span>
                        </ng-container>
                     </ng-container>
   
                     <ng-container *ngIf="getBillingPartyRef( shipment ) as ref">
                        <header color="primary">Ref #</header>
                        <span>
                           <ng-container *ngIf="ref.type">{{ref.type | uppercase}} - </ng-container>
                           {{ref.data}}<br/>
                        </span>
                     </ng-container>
                  </div>
   
                  <div class="summary-shipper">
                     <b color="primary">Shipper</b><br/>
                     {{shipment.shipper.name}}, {{shipment.shipper.city}}<br/>
                     Pickup Date
                     <ng-container *ngIf="shipment.pdatefrom">{{shipment.pdatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="shipment.pdatefrom && shipment.pdateto"> - </ng-container>
                     <ng-container *ngIf="shipment.pdateto">{{shipment.pdateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Pickup Time
                     <ng-container *ngIf="shipment.ptimefrom">{{shipment.ptimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="shipment.ptimefrom && shipment.ptimeto"> - </ng-container>
                     <ng-container *ngIf="shipment.ptimeto">{{shipment.ptimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>
   
                  <div class="summary-consignee">
                     <b color="primary">Consignee</b><br/>
                     {{shipment.consignee.name}}, {{shipment.consignee.city}}<br/>
                     Delivery Date
                     <ng-container *ngIf="shipment.ddatefrom">{{shipment.ddatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="shipment.ddatefrom && shipment.ddateto"> - </ng-container>
                     <ng-container *ngIf="shipment.ddateto">{{shipment.ddateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Delivery Time
                     <ng-container *ngIf="shipment.dtimefrom">{{shipment.dtimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="shipment.dtimefrom && shipment.dtimeto"> - </ng-container>
                     <ng-container *ngIf="shipment.dtimeto">{{shipment.dtimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>
   
                  <ng-container *ngIf="shipment.station as station">
                     <div class="summary-station">
                        <b color="primary">Station</b><br/>
                        {{station.name}}<br/>
                        {{station.address1}}<br/>
                        <ng-container *ngIf="station.address2">{{station.address2}}<br/></ng-container>
                        {{station.city}}, {{station.state}} {{station.postalcode}}<br/>
                        <ng-container *ngIf="station.country">{{ countries.countryName( station.country ) | async }}<br/></ng-container>
                        <ng-container *ngIf="station.phone || station.email">
   
                        <br/>
                        <ng-container *ngIf="station.phone">{{station.phone}}<br/></ng-container>
                        <ng-container *ngIf="station.email">{{station.email}}<br/></ng-container>
                     </ng-container>
                     </div>
                  </ng-container>

                  <div class="summary-dates" *ngIf="shipment.fwq != null && shipment.fwq != ''">
                     <b color="primary">Quotation #</b><br/>
                     <a routerLink="/manage/quotations/{{ shipment.fwq }}">{{ shipment.fwq }}</a><br/>
                  </div>
               </div>
   
               <lib-tracker-line [mode]="[shipment.mode]" [milestoneObj]="shipment.milestones" [plannedMilestonesObj]="shipment.plannedMilestones"></lib-tracker-line>
   
               <div class="details">
                  <mat-expansion-panel class="bordered" expanded>
                     <mat-expansion-panel-header>Booking Details</mat-expansion-panel-header>
                     <div class="flex">
                        <div>
                           <div *ngIf="shipment.shipType">Type</div>
                           {{shipment.shipType | titlecase}}
                        </div>
   
                        <div *ngIf="shipment.shipType === 'international'">
                           <div>Mode</div>
                           {{shipment.mode | titlecase}}
                        </div>
   
                        <div *ngIf="shipment.movementType">
                           <div>Movement Type</div>
                           {{shipment.movementType.from | titlecase}} To {{shipment.movementType.to | titlecase}}
                        </div>
   
                        <div *ngIf="shipment.trafficDirection">
                           <div>Traffic Direction</div>
                           {{shipment.trafficDirection | titlecase}}
                        </div>
   
                        <div *ngIf="shipment.airportfrom">
                           <div>Origin Airport</div>
                           {{shipment.airportfrom | uppercase}}
                        </div>
   
                        <div *ngIf="shipment.airportto">
                           <div>Destination Airport</div>
                           {{shipment.airportto | uppercase}}
                        </div>
   
                        <div *ngIf="shipment.origin">
                           <div>Origin Port</div>
                           {{shipment.origin | uppercase}}
                        </div>
   
                        <div *ngIf="shipment.destination">
                           <div>Destination Port</div>
                           {{shipment.destination | uppercase}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <div class="party-card">
                     <ng-container *ngFor="let party of [ 'shipper', 'consignee', 'bill_to' ]">
                        <mat-expansion-panel [class]="'mat-expansion-panel bordered ' + party" expanded hideToggle *ngIf="shipment[party] as data">
                           <mat-expansion-panel-header>{{party | spacers | titlecase}}</mat-expansion-panel-header>
                           <div class="content">
                              <div>{{data.name}}</div>
                              {{data.address1}}<br/>
                              <ng-container *ngIf="data.address2">{{data.address2}}<br/></ng-container>
                              <ng-container *ngIf="data.address3">{{data.address3}}<br/></ng-container>
                              {{data.city}}, {{data.state}} {{data.postalcode}}<br/>
                              <ng-container *ngIf="data.country">{{ countries.countryName( data.country ) | async }}<br/></ng-container>
                              <br *ngIf="data.phone || data.email" />
                              <ng-container *ngIf="data.phone">{{data.phone}}<br/></ng-container>
                              <ng-container *ngIf="data.email">
                                 <a href="mailto:{{data.email}}" color="accent" class="common-tdnone">{{data.email}}<br/></a>
                              </ng-container>
                              <ng-container *ngIf="data.contact as contact">
                                 <br *ngIf="contact.name || contact.phone || contact.email" />
                                 <ng-container *ngIf="contact.name">{{contact.name}}<br/></ng-container>
                                 <ng-container *ngIf="contact.phone">{{contact.phone}}<br/></ng-container>
                                 <ng-container *ngIf="contact.email">
                                    <a href="mailto:{{contact.email}}" color="accent" class="common-tdnone">{{contact.email}}</a>
                                 </ng-container>
                              </ng-container>
                           </div>
                        </mat-expansion-panel>
                     </ng-container>
                  </div>
   
                  <mat-expansion-panel class="bordered" expanded>
                     <mat-expansion-panel-header>
                        Service Level and Dates
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div *ngIf="shipment.servicelevel">
                           <div>Service Level</div>
                           {{shipment.servicelevel}}
                        </div>
   
                        <div *ngIf="shipment.incoterms">
                           <div>Incoterms</div>
                           {{shipment.incoterms}}
                        </div>

                        <div class="accessorials-container" *ngIf="shipment.accessorials && shipment.accessorials.length">
                           <div>Accessorials</div>
                           <span
                             #textContent
                             class="accessorials-text">
                             {{ getAccessorial(shipment.accessorials , expanded) | titlecase}}
                             <span *ngIf="!expanded && showToggle" class="more-toggle" (click)="expanded = true">{{ ' + '+ remainingAccessorials +' More'}}</span>
                           </span>
                         </div>
   
                        <div *ngIf="shipment.awbType">
                           <div>AWB Type</div>
                           {{shipment.awbType}}
                        </div>
   
                        <div *ngIf="shipment.teu">
                           <div>Number of TEU</div>
                           {{shipment.teu}}
                        </div>
   
                        <div class="hr"></div>
   
                        <div #pickup>
                           <div>Pickup</div>
                           <ng-container *ngIf="shipment.pdatefrom">{{shipment.pdatefrom | date}}</ng-container>
                           <ng-container *ngIf="shipment.pdatefrom && shipment.pdateto"> - </ng-container>
                           <ng-container *ngIf="shipment.pdateto">{{shipment.pdateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="shipment.ptimefrom">{{shipment.ptimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="shipment.ptimefrom && shipment.ptimeto"> - </ng-container>
                           <ng-container *ngIf="shipment.ptimeto">{{shipment.ptimeto | time : 'h:mm A'}}</ng-container>
                        </div>
   
                        <div #delivery>
                           <div>Delivery</div>
                           <ng-container *ngIf="shipment.ddatefrom">{{shipment.ddatefrom | date}}</ng-container>
                           <ng-container *ngIf="shipment.ddatefrom && shipment.ddateto"> - </ng-container>
                           <ng-container *ngIf="shipment.ddateto">{{shipment.ddateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="shipment.dtimefrom">{{shipment.dtimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="shipment.dtimefrom && shipment.dtimeto"> - </ng-container>
                           <ng-container *ngIf="shipment.dtimeto">{{shipment.dtimeto | time : 'h:mm A'}}</ng-container>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.containers?.length || shipment.calculator?.length">
                     <mat-expansion-panel-header>
                        Item Calculator
                     </mat-expansion-panel-header>
   
                     <div class="flex" *ngIf="shipment.itemsType">
                        <div *ngIf="shipment.shippingType">
                           <div>Shipping type</div>
                           {{shipment.shippingType}}
                        </div>
   
                        <div class="hr"></div>
                     </div>
   
                     <ng-container *ngIf="shipment.calculator && shipment.calculator.length">
                        <div class="flex">
                           <div *ngFor="let calc of shipment.calculator; let i = index" class="calc">
                              <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                           </div>
                        </div>
   
                        <div class="hr"></div>
                     </ng-container>
   
                     <ng-container *ngIf="shipment.containers && shipment.containers.length">
                        <div *ngFor="let container of shipment.containers; let i = index">
                           <div class="header" color="primary" class="common-mb1em common-bold">Container {{i + 1}}</div>
   
                           <div class="flex">
                              <div *ngIf="container.number">
                                 <div>Container Number</div>
                                 <div>{{container.number}}</div>
                              </div>
   
                              <div>
                                 <div>Container Type</div>
                                 <div>{{container.type}}</div>
                              </div>
   
                              <div *ngIf="container.sealNumber">
                                 <div>Seal Number</div>
                                 <div>{{container.sealNumber}}</div>
                              </div>
                           </div>
   
                           <div class="flex">
                              <div *ngFor="let calc of container.items; let i = index" class="calc">
                                 <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                              </div>
                           </div>
   
                           <div class="hr"></div>
                        </div>
                     </ng-container>
   
                     <ng-template #calcDetails let-calc="calc" let-i="i">
                        <div>Item {{i+1}}</div>
                        <span color="primary" class="common-inlineblock common-w17ex">Pieces </span>{{calc.pieces}}<br/>
                        <span color="primary" class="common-inlineblock common-w17ex">Weight </span>{{[calc] | totaldualweight}}<br/>
                        <ng-container *ngIf='calc.length && calc.width && calc.height && calc.measure_type'>
                           <span color="primary" class="common-inlineblock common-w17ex">Dimensions </span>{{calc.length}} x {{calc.width}} x {{calc.height}} {{calc.measure_type}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.description">
                           <span color="primary" class="common-inlineblock common-w17ex">Item Description </span>{{calc.description}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.reference">
                           <span color="primary" class="common-inlineblock common-w17ex">Item Reference </span>{{calc.reference}}<br/>
                        </ng-container>
                     </ng-template>
   
                     <div class="flex" *ngIf="allItems | async as items">
                        <div>
                           <div>Total Pieces</div>
                           <div>{{items | total : 'pieces' | number}}</div>
                        </div>
   
                        <div>
                           <div>Total Weight</div>
                           <div>{{items | totaldualweight }}</div>
                        </div>
   
                        <div *ngIf="items | totalvolume">
                           <div>Volume</div>
                           <div>{{items | totaldualvolume }}</div>
                        </div>
   
                        <div *ngIf="shipment.containers?.length">
                           <div>Total Containers</div>
                           <div>{{shipment.containers.length}}</div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.references?.length">
                     <mat-expansion-panel-header>
                        Reference Details
                     </mat-expansion-panel-header>
   
                     <ng-container *ngIf="[ 'party', 'type', 'data' ] as columns">
                        <mat-table [dataSource]="shipment.references" class="rotate-cdk-table">
                           <ng-container matColumnDef="party">
                              <mat-header-cell *matHeaderCellDef>Party</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Party</div>
                                 <div class="cell">{{row.party | spacers | titlecase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="type">
                              <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Type</div>
                              <div class="cell">{{row.type | uppercase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="data">
                              <mat-header-cell *matHeaderCellDef class="common-fg2">Reference Number</mat-header-cell>
                              <mat-cell *matCellDef="let row" class="common-fg2">
                              <div class="header">Reference Number</div>
                              <div class="cell">{{row.data}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                           <mat-row *matRowDef="let row; columns: columns"></mat-row>
                        </mat-table>
                     </ng-container>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.tradeshow?.length">
                     <mat-expansion-panel-header>
                        Tradeshow Details
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div *ngFor="let t of shipment.tradeshow">
                           <div>{{t.location | titlecase}}</div>
                           <span color="primary" class="common-inlineblock common-w15ex">Show Name </span>{{t.name}}<br/>
                           <span color="primary" class="common-inlineblock common-w15ex">Booth Number </span>{{t.booth}}<br/>
                           <span color="primary" class="common-inlineblock common-w15ex">Exhibitor </span>{{t.exhibitor}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.risks">
                     <mat-expansion-panel-header>
                        Risks
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div>
                           <div>Risk Type</div>
                           {{(shipment.risks.type | spacers | titlecase) || 'None'}}
                        </div>
                        <div *ngIf="shipment.risks && shipment.risks.amount">
                           <div>Amount</div>
                           {{shipment.risks.amount | currencycode: shipment.risks.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.description || shipment.specialinstructions || (shipment.cod && shipment.cod.amount)">
                     <mat-expansion-panel-header>
                        Description and Instructions
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <ng-container *ngIf="shipment.cod && shipment.cod.type">
                           <div *ngIf="shipment.cod as cod">
                              <div>COD</div>
                              {{cod.type | titlecase}} {{cod.amount | currencycode: cod.currency}}
                           </div>
                        </ng-container>
   
                        <div class="full" #description *ngIf="shipment.description">
                           <div>Shipment Description</div>
                           <div class="wordwrap">
                              {{shipment.description}}
                           </div>
                        </div>
   
                        <div class="full" #specialinstuctions *ngIf="shipment.specialinstructions">
                           <div>Special Instructions</div>
                           <div class="wordwrap">
                              {{shipment.specialinstructions}}
                           </div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.pod">
                     <mat-expansion-panel-header>
                        POD Information
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <div *ngIf="shipment.pod.date">
                           <div>POD Date</div>
                           {{shipment.pod.date | date}}
                        </div>
   
                        <div *ngIf="shipment.pod.time">
                           <div>POD Time</div>
                           {{shipment.pod.time | time : 'h:mm A'}} {{shipment.pod.timezone}}
                        </div>
   
                        <div *ngIf="shipment.pod.name">
                           <div>Signed</div>
                           {{shipment.pod.name}}
                        </div>
   
                        <div *ngIf="shipment.pod.pieces">
                           <div>Pieces</div>
                           {{shipment.pod.pieces}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="shipment.customs">
                     <mat-expansion-panel-header>Customs Details</mat-expansion-panel-header>
   
                     <div class="flex">
                        <div *ngIf="shipment.customs.value">
                           <div>Goods Value</div>
                           {{shipment.customs.value | currencycode: shipment.customs.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <ng-container *ngIf="shipment.attachments?.length || allowNewAttachments">
                     <br/>
                     <lib-attachment-display
                     [attachments]="shipment.attachments || []"
                     [attachmentTypesEnum]="enums.attachmentTypes(shipment.shipType, shipment.mode)"
                     [updateForm]="attachmentUpdates"
                     [allowNewAttachments]="allowNewAttachments"
   
                     (save)="saveAttachments( shipment.hawb, $event )"
                  ></lib-attachment-display>
                  </ng-container>
               </div>
   
               <div class="tracking common-mt1em" *ngIf="shipment.statuses?.length">
                  <h2 color="primary">Tracking</h2>
   
                  <mat-table [dataSource]="getSortedStatusesById( shipment.statuses )" class="rotate-cdk-table">
                     <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                           <div class="header">Date</div>
                           <div class="cell">{{row.date | date: 'mediumDate'}}</div>
                        </mat-cell>
                     </ng-container>
   
                     <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef class="common-fg3">Status</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="common-fg3">
                           <div class="header">Status</div>
                           <div class="cell">
                              {{ row.event ? row.event : row.status }}
                              <ng-container *ngIf="row.reason">
                                 <br/>
                                 {{row.reason}}
                              </ng-container>
                           </div>
                        </mat-cell>
                     </ng-container>
   
                     <mat-header-row *matHeaderRowDef="[ 'date', 'status' ]"></mat-header-row>
                     <mat-row *matRowDef="let row; columns: [ 'date', 'status' ]"></mat-row>
                  </mat-table>
               </div>
            </div>
         </ng-container>
      </ng-container>
   </ng-container>
   <ng-container *ngIf="mode === 'quote'">
      <ng-container *ngIf="quoteDetails.load( hawb ) | async as quotation; else loading">
         <ng-container *ngIf="quotation; else invalid">
            <div class="quotation-details">
               <h2 color="primary">Quotation Request Details</h2>

               <div class="service-label">Request #{{ quotation.fwq }}</div>

               <div class="summary">
                  <div class="list summary-details">
                     <ng-container *ngIf="quotation.serviceLevel">
                        <header color="primary">Service Level</header>
                        <span> {{ quotation.serviceLevel }}<br/></span>
                     </ng-container>
   
                     <ng-container *ngIf="allItems | async as items">
                        <header color="primary">Total Pieces</header>
                        <span> {{items | total : 'pieces' | number}}<br/></span>
   
                        <header color="primary">Total Weight</header>
                        <span> {{items | totaldualweight }}<br/></span>
   
                        <ng-container *ngIf="items | totalvolume">
                           <header color="primary">Volume</header>
                           <span> {{items | totaldualvolume }}<br/></span>
                        </ng-container>
                        
                        <ng-container *ngIf="quotation.milestones?.ready">
                           <header color="primary">Total Cost</header>
                           <span> {{ quotation.cost | currencycode : quotation.costCurrency }}<br/></span>
                        </ng-container>
                     </ng-container>
   
                     <ng-container *ngIf="getBillingPartyRef( quotation ) as ref">
                        <header color="primary">Ref #</header>
                        <span>
                           <ng-container *ngIf="ref.type">{{ref.type | uppercase}} - </ng-container>
                           {{ref.data}}<br/>
                        </span>
                     </ng-container>
                  </div>
   
                  <div class="summary-shipper">
                     <b color="primary">Shipper</b><br/>
                     <ng-container *ngIf="quotation.shipper.name || quotation.shipper.city">
                        {{ quotation.shipper.name }}{{ quotation.shipper.name && quotation.shipper.city ? ', ' : '' }}{{ quotation.shipper.city }}<br />
                     </ng-container>
                     Pickup Date
                     <ng-container *ngIf="quotation.pdatefrom">{{quotation.pdatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="quotation.pdatefrom && quotation.pdateto"> - </ng-container>
                     <ng-container *ngIf="quotation.pdateto">{{quotation.pdateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Pickup Time
                     <ng-container *ngIf="quotation.ptimefrom">{{quotation.ptimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="quotation.ptimefrom && quotation.ptimeto"> - </ng-container>
                     <ng-container *ngIf="quotation.ptimeto">{{quotation.ptimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>
   
                  <div class="summary-consignee">
                     <b color="primary">Consignee</b><br/>
                     <ng-container *ngIf="quotation.consignee.name || quotation.consignee.city">
                        {{ quotation.consignee.name }}{{ quotation.consignee.name && quotation.consignee.city ? ', ' : '' }}{{ quotation.consignee.city }}<br />
                     </ng-container>
                     Delivery Date
                     <ng-container *ngIf="quotation.ddatefrom">{{quotation.ddatefrom | date:'shortDate'}}</ng-container>
                     <ng-container *ngIf="quotation.ddatefrom && quotation.ddateto"> - </ng-container>
                     <ng-container *ngIf="quotation.ddateto">{{quotation.ddateto | date:'shortDate'}}</ng-container>
                     <br/>
   
                     Delivery Time
                     <ng-container *ngIf="quotation.dtimefrom">{{quotation.dtimefrom | time : 'h:mm A'}}</ng-container>
                     <ng-container *ngIf="quotation.dtimefrom && quotation.dtimeto"> - </ng-container>
                     <ng-container *ngIf="quotation.dtimeto">{{quotation.dtimeto | time : 'h:mm A'}}</ng-container>
                     <br/>
                  </div>

                  <div class="summary-bill-to">
                     <b color="primary">Bill To</b><br/>
                     {{quotation.bill_to.name}}<br/>
                     {{quotation.bill_to.address1}}<br/>
                     {{quotation.bill_to.address2}}<br/>
                     <ng-container *ngIf="quotation.bill_to.address3">{{quotation.bill_to.address3}}<br/></ng-container>
                     {{quotation.bill_to.city}}, {{quotation.bill_to.state}} {{quotation.bill_to.postalcode}}<br/>
                     {{quotation.bill_to.country}}
                     <br/>
                  </div>
   
                  <ng-container *ngIf="quotation.station as station">
                     <div class="summary-station">
                        <b color="primary">Station</b><br/>
                        {{station.name}}<br/>
                        {{station.address1}}<br/>
                        <ng-container *ngIf="station.address2">{{station.address2}}<br/></ng-container>
                        {{station.city}}, {{station.state}} {{station.postalcode}}<br/>
                        <ng-container *ngIf="station.country">{{ countries.countryName( station.country ) | async }}<br/></ng-container>
                        <ng-container *ngIf="station.phone || station.email">
   
                           <br/>
                           <ng-container *ngIf="station.phone">{{station.phone}}<br/></ng-container>
                           <ng-container *ngIf="station.email">{{station.email}}<br/></ng-container>
                        </ng-container>
                     </div>
                  </ng-container>

                  <div class="summary-dates">
                     <b color="primary">Create Date</b><br/>
                     <ng-container *ngIf="quotation.createdDate">{{ quotation.createdDate }}</ng-container><br/><br/>
                     <b color="primary">Validity Date</b><br/>
                     {{ quotation.validToDate | utcToLocal: quotation.validToTime }}<br/><br/>
                     <b color="primary">Quotation #</b><br/>
                     {{ quotation.fwq }}<br/>
                  </div>
               </div>
               
               <lib-quote-tracker-line [mode]="[quotation.mode]" [milestoneObj]="quotation.milestones" [quotePage]="true" (quoteStatus)="quoteStatus=$event"></lib-quote-tracker-line>

               <div class="details">
                  <mat-expansion-panel class="bordered" expanded>
                     <mat-expansion-panel-header>Booking Details</mat-expansion-panel-header>
                     <div class="flex">
                        <div>
                           <div *ngIf="quotation.quoteType">Type</div>
                           {{quotation.quoteType | titlecase}}
                        </div>
   
                        <div *ngIf="quotation.quoteType === 'international'">
                           <div>Mode</div>
                           {{quotation.mode | titlecase}}
                        </div>
   
                        <div *ngIf="quotation.movementType">
                           <div>Movement Type</div>
                           {{quotation.movementType.from | titlecase}} To {{quotation.movementType.to | titlecase}}
                        </div>
   
                        <div *ngIf="quotation.trafficDirection">
                           <div>Traffic Direction</div>
                           {{quotation.trafficDirection | titlecase}}
                        </div>
   
                        <div *ngIf="quotation.airportfrom">
                           <div>Origin Airport</div>
                           {{quotation.airportfrom | uppercase}}
                        </div>
   
                        <div *ngIf="quotation.airportto">
                           <div>Destination Airport</div>
                           {{quotation.airportto | uppercase}}
                        </div>
   
                        <div *ngIf="quotation.origin">
                           <div>Origin Port</div>
                           {{quotation.origin | uppercase}}
                        </div>
   
                        <div *ngIf="quotation.destination">
                           <div>Destination Port</div>
                           {{quotation.destination | uppercase}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <div class="party-card">
                     <ng-container *ngFor="let party of [ 'shipper', 'consignee', 'bill_to' ]">
                        <mat-expansion-panel [class]="'mat-expansion-panel bordered ' + party" expanded hideToggle *ngIf="quotation[party] as data">
                           <mat-expansion-panel-header>{{party | spacers | titlecase}}</mat-expansion-panel-header>
                           <div class="content">
                              <ng-container *ngIf="data.name">{{data.name}}<br/></ng-container>
                              <ng-container *ngIf="data.address1">{{data.address1}}<br/></ng-container>
                              <ng-container *ngIf="data.address2">{{data.address2}}<br/></ng-container>
                              <ng-container *ngIf="data.address3">{{data.address3}}<br/></ng-container>
                              <ng-container *ngIf="data.city || data.state || data.postalcode">
                                 {{data.city}}{{ data.city && ( data.state || data.postalcode ) ? ', ' : '' }}{{data.state}} {{data.postalcode}}<br/>
                              </ng-container>
                              <ng-container *ngIf="data.country">{{ countries.countryName( data.country ) | async }}<br/></ng-container>
                              <br *ngIf="data.phone || data.email" />
                              <ng-container *ngIf="data.phone">{{data.phone}}<br/></ng-container>
                              <ng-container *ngIf="data.email">
                                 <a href="mailto:{{data.email}}" color="accent" class="common-tdnone">{{data.email}}<br/></a>
                              </ng-container>
                              <ng-container *ngIf="data.contact as contact">
                                 <br *ngIf="contact.name || contact.phone || contact.email" />
                                 <ng-container *ngIf="contact.name">{{contact.name}}<br/></ng-container>
                                 <ng-container *ngIf="contact.phone">{{contact.phone}}<br/></ng-container>
                                 <ng-container *ngIf="contact.email">
                                    <a href="mailto:{{contact.email}}" color="accent" class="common-tdnone">{{contact.email}}</a>
                                 </ng-container>
                              </ng-container>
                           </div>
                        </mat-expansion-panel>
                     </ng-container>
                  </div>
   
                  <mat-expansion-panel class="bordered" expanded>
                     <mat-expansion-panel-header>
                        Service Level and Dates
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div *ngIf="quotation.serviceLevel">
                           <div>Service Level</div>
                           {{ quotation.serviceLevel }}
                        </div>
   
                        <div *ngIf="quotation.incoterms">
                           <div>Incoterms</div>
                           {{quotation.incoterms}}
                        </div>

                        <div class="accessorials-container" *ngIf="quotation.accessorials && quotation.accessorials.length">
                           <div>Accessorials</div>
                           <span
                             #textContent
                             class="accessorials-text">
                             {{ getAccessorial(quotation.accessorials , expanded) | titlecase}}
                             <span *ngIf="!expanded && showToggle" class="more-toggle" (click)="expanded = true">{{ ' + '+ remainingAccessorials +' More'}}</span>
                           </span>
                         </div>
   
                        <div *ngIf="quotation.awbType">
                           <div>AWB Type</div>
                           {{quotation.awbType}}
                        </div>
   
                        <!-- <div *ngIf="quotation.teu">
                           <div>Number of TEU</div>
                           {{quotation.teu}}
                        </div> -->
   
                        <div class="hr"></div>
   
                        <div #pickup>
                           <div>Pickup</div>
                           <ng-container *ngIf="quotation.pdatefrom">{{quotation.pdatefrom | date}}</ng-container>
                           <ng-container *ngIf="quotation.pdatefrom && quotation.pdateto"> - </ng-container>
                           <ng-container *ngIf="quotation.pdateto">{{quotation.pdateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="quotation.ptimefrom">{{quotation.ptimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="quotation.ptimefrom && quotation.ptimeto"> - </ng-container>
                           <ng-container *ngIf="quotation.ptimeto">{{quotation.ptimeto | time : 'h:mm A'}}</ng-container>
                        </div>
   
                        <div #delivery>
                           <div>Delivery</div>
                           <ng-container *ngIf="quotation.ddatefrom">{{quotation.ddatefrom | date}}</ng-container>
                           <ng-container *ngIf="quotation.ddatefrom && quotation.ddateto"> - </ng-container>
                           <ng-container *ngIf="quotation.ddateto">{{quotation.ddateto | date}}</ng-container>
                           <br/>
   
                           <ng-container *ngIf="quotation.dtimefrom">{{quotation.dtimefrom | time : 'h:mm A'}}</ng-container>
                           <ng-container *ngIf="quotation.dtimefrom && quotation.dtimeto"> - </ng-container>
                           <ng-container *ngIf="quotation.dtimeto">{{quotation.dtimeto | time : 'h:mm A'}}</ng-container>
                        </div>
                     </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel class="bordered" expanded *ngIf="quoteStatus?.code.toLowerCase()!='submitted' && quotation.charges?.chargeItems">
                     <mat-expansion-panel-header>
                        Charges
                     </mat-expansion-panel-header>
   
                     <ng-container *ngIf="[ 'description', 'quantity', 'rate', 'amount' ] as columns">
                        <mat-table [dataSource]="quotation.charges?.chargeItems" class="rotate-cdk-table">
                           <ng-container matColumnDef="description">
                              <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Description</div>
                                 <div class="cell">{{row.chargeDescription | spacers | titlecase}}</div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="quantity">
                              <mat-header-cell *matHeaderCellDef>Quantity</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Quantity</div>
                              <div class="cell">{{row.chargeQuantity }} </div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                           </ng-container>

                           <ng-container matColumnDef="rate">
                              <mat-header-cell *matHeaderCellDef>Rate</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Rate</div>
                              <div class="cell">{{ +row.chargeRate | tofixed : 2 }} </div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef>Total Due</mat-footer-cell>
                           </ng-container>

                           <ng-container matColumnDef="amount">
                              <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Amount</div>
                              <div class="cell">{{row.chargeCodeAmount | currencycode : row.chargeCodeCurrency }} </div>
                              </mat-cell>
                              <mat-footer-cell *matFooterCellDef> {{ quotation.charges.totalCharges | currencycode : quotation.charges.totalChargesCurrency }}</mat-footer-cell>
                           </ng-container>
   
                           <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                           <mat-row *matRowDef="let row; columns: columns"></mat-row>
                           <mat-footer-row *matFooterRowDef="columns"></mat-footer-row>
                        </mat-table>
                     </ng-container>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="quotation.containers?.length || quotation.calculator?.length">
                     <mat-expansion-panel-header>
                        Item Calculator
                     </mat-expansion-panel-header>
   
                     <div class="flex" *ngIf="quotation.itemsType">
                        <div *ngIf="quotation.shippingType">
                           <div>Shipping type</div>
                           {{quotation.shippingType}}
                        </div>
   
                        <div class="hr"></div>
                     </div>
   
                     <ng-container *ngIf="quotation.calculator && quotation.calculator.length">
                        <div class="flex">
                           <div *ngFor="let calc of quotation.calculator; let i = index" class="calc">
                              <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                           </div>
                        </div>
   
                        <div class="hr"></div>
                     </ng-container>
   
                     <ng-container *ngIf="quotation.containers && quotation.containers.length">
                        <div *ngFor="let container of quotation.containers; let i = index">
                           <div class="header" color="primary" class="common-mb1em common-bold">Container {{i + 1}}</div>
   
                           <div class="flex">
                              <div *ngIf="container.number">
                                 <div>Container Number</div>
                                 <div>{{container.number}}</div>
                              </div>
   
                              <div>
                                 <div>Container Type</div>
                                 <div>{{container.type}}</div>
                              </div>
   
                              <div *ngIf="container.sealNumber">
                                 <div>Seal Number</div>
                                 <div>{{container.sealNumber}}</div>
                              </div>
                           </div>
   
                           <div class="flex">
                              <div *ngFor="let calc of container.items; let i = index" class="calc">
                                 <ng-container *ngTemplateOutlet="calcDetails; context: {calc: calc, i: i}"></ng-container>
                              </div>
                           </div>
   
                           <div class="hr"></div>
                        </div>
                     </ng-container>
   
                     <ng-template #calcDetails let-calc="calc" let-i="i">
                        <div>Item {{i+1}}</div>
                        <span color="primary" class="common-inlineblock common-w17ex">Pieces </span>{{calc.pieces}}<br/>
                        <span color="primary" class="common-inlineblock common-w17ex">Weight </span>{{[calc] | totaldualweight}}<br/>
                        <ng-container *ngIf='calc.length && calc.width && calc.height && calc.measure_type'>
                           <span color="primary" class="common-inlineblock common-w17ex">Dimensions </span>{{calc.length}} x {{calc.width}} x {{calc.height}} {{calc.measure_type}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.description">
                           <span color="primary" class="common-inlineblock common-w17ex">Item Description </span>{{calc.description}}<br/>
                        </ng-container>
                        <ng-container *ngIf="calc.reference">
                           <span color="primary" class="common-inlineblock common-w17ex">Item Reference </span>{{calc.reference}}<br/>
                        </ng-container>
                     </ng-template>
   
                     <div class="flex" *ngIf="allItems | async as items">
                        <div>
                           <div>Total Pieces</div>
                           <div>{{items | total : 'pieces' | number}}</div>
                        </div>
   
                        <div>
                           <div>Total Weight</div>
                           <div>{{items | totaldualweight }}</div>
                        </div>
   
                        <div *ngIf="items | totalvolume">
                           <div>Volume</div>
                           <div>{{items | totaldualvolume }}</div>
                        </div>
   
                        <div *ngIf="quotation.containers?.length">
                           <div>Total Containers</div>
                           <div>{{quotation.containers.length}}</div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="quotation.references?.length">
                     <mat-expansion-panel-header>
                        Reference Details
                     </mat-expansion-panel-header>
   
                     <ng-container *ngIf="[ 'party', 'type', 'data' ] as columns">
                        <mat-table [dataSource]="quotation.references" class="rotate-cdk-table">
                           <ng-container matColumnDef="party">
                              <mat-header-cell *matHeaderCellDef>Party</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Party</div>
                                 <div class="cell">{{row.party | spacers | titlecase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="type">
                              <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                              <mat-cell *matCellDef="let row">
                                 <div class="header">Type</div>
                              <div class="cell">{{row.type | uppercase}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <ng-container matColumnDef="data">
                              <mat-header-cell *matHeaderCellDef class="common-fg2">Reference Number</mat-header-cell>
                              <mat-cell *matCellDef="let row" class="common-fg2">
                              <div class="header">Reference Number</div>
                              <div class="cell">{{row.data}}</div>
                              </mat-cell>
                           </ng-container>
   
                           <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                           <mat-row *matRowDef="let row; columns: columns"></mat-row>
                        </mat-table>
                     </ng-container>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="quotation.tradeshow?.length">
                     <mat-expansion-panel-header>
                        Tradeshow Details
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div *ngFor="let t of quotation.tradeshow">
                           <div>{{t.location | titlecase}}</div>
                           <span color="primary" class="common-inlineblock common-w15ex">Show Name </span>{{t.name}}<br/>
                           <span color="primary" class="common-inlineblock common-w15ex">Booth Number </span>{{t.booth}}<br/>
                           <span color="primary" class="common-inlineblock common-w15ex">Exhibitor </span>{{t.exhibitor}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="quotation.risks">
                     <mat-expansion-panel-header>
                        Risks
                     </mat-expansion-panel-header>
                     <div class="flex">
                        <div>
                           <div>Risk Type</div>
                           {{(quotation.risks.type | spacers | titlecase) || 'None'}}
                        </div>
                        <div *ngIf="quotation.risks && quotation.risks.amount">
                           <div>Amount</div>
                           {{quotation.risks.amount | currencycode: quotation.risks.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <mat-expansion-panel class="bordered" expanded *ngIf="quotation.description || quotation.specialinstructions || (quotation.cod && quotation.cod.amount)">
                     <mat-expansion-panel-header>
                        Description and Instructions
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <ng-container *ngIf="quotation.cod && quotation.cod.type">
                           <div *ngIf="quotation.cod as cod">
                              <div>COD</div>
                              {{cod.type | titlecase}} {{cod.amount | currencycode: cod.currency}}
                           </div>
                        </ng-container>
   
                        <div class="full" #description *ngIf="quotation.description">
                           <div>Quotation Description</div>
                           <div class="wordwrap">
                              {{quotation.description}}
                           </div>
                        </div>
   
                        <div class="full" #specialinstuctions *ngIf="quotation.specialinstructions">
                           <div>Special Instructions</div>
                           <div class="wordwrap">
                              {{quotation.specialinstructions}}
                           </div>
                        </div>
                     </div>
                  </mat-expansion-panel>
   
                  <!-- <mat-expansion-panel class="bordered" expanded *ngIf="quotation.pod">
                     <mat-expansion-panel-header>
                        POD Information
                     </mat-expansion-panel-header>
   
                     <div class="flex">
                        <div *ngIf="quotation.pod.date">
                           <div>POD Date</div>
                           {{quotation.pod.date | date}}
                        </div>
   
                        <div *ngIf="quotation.pod.time">
                           <div>POD Time</div>
                           {{quotation.pod.time | time : 'h:mm A'}} {{quotation.pod.timezone}}
                        </div>
   
                        <div *ngIf="quotation.pod.name">
                           <div>Signed</div>
                           {{quotation.pod.name}}
                        </div>
   
                        <div *ngIf="quotation.pod.pieces">
                           <div>Pieces</div>
                           {{quotation.pod.pieces}}
                        </div>
                     </div>
                  </mat-expansion-panel> -->
   
                  <!-- <mat-expansion-panel class="bordered" expanded *ngIf="quotation.customs">
                     <mat-expansion-panel-header>Customs Details</mat-expansion-panel-header>
   
                     <div class="flex">
                        <div *ngIf="quotation.customs.value">
                           <div>Goods Value</div>
                           {{quotation.customs.value | currencycode: quotation.customs.currency}}
                        </div>
                     </div>
                  </mat-expansion-panel> -->
   
                  <ng-container *ngIf="quotation.attachments?.length || allowNewAttachments">
                     <br/>
                     <lib-attachment-display
                     [attachments]="quotation.attachments || []"
                     [attachmentTypesEnum]="enums.attachmentTypes(quotation.quoteType, quotation.mode)"
                     [updateForm]="attachmentUpdates"
                     [allowNewAttachments]="allowNewAttachments"
   
                     (save)="saveQuoteAttachments( quotation.fwq, $event )"
                  ></lib-attachment-display>
                  </ng-container>
               </div>
            </div>
         </ng-container>
      </ng-container>
   </ng-container>
</ng-container>
